var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { WithDisposable } from '@blocksuite/lit';
import { css, html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
const styles = css `
  :host {
    display: block;
    box-sizing: border-box;
    padding: 8px;
    width: 220px;
  }

  .notes-setting-menu-container {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    width: 100%;
  }

  .notes-setting-menu-item {
    display: flex;
    box-sizing: border-box;
    width: 100%;
    height: 28px;
    padding: 4px 12px;
    align-items: center;
  }

  .notes-setting-menu-item .setting-label {
    font-family: sans-serif;
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    color: var(--affine-text-secondary-color);
    padding: 0 4px;
  }

  .notes-setting-menu-item.action {
    gap: 4px;
  }

  .notes-setting-menu-item .action-label {
    width: 138px;
    height: 20px;
    padding: 0 4px;
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    color: var(--affine-text-primary-color);
  }

  .notes-setting-menu-item .toggle-button {
    display: flex;
  }
`;
export class TOCNotesSettingMenu extends WithDisposable(LitElement) {
    constructor() {
        super(...arguments);
        this.hideIcon = false;
    }
    render() {
        return html `<div
      class="notes-setting-menu-container"
      @click=${(e) => e.stopPropagation()}
    >
      <div class="notes-setting-menu-item">
        <div class="setting-label">Settings</div>
      </div>
      <div class="notes-setting-menu-item action">
        <div class="action-label">Hide type icon</div>
        <div class="toggle-button">
          <toggle-switch
            .on=${this.hideIcon}
            .onChange=${this.toggleHideIcon}
          ></toggle-switch>
        </div>
      </div>
    </div>`;
    }
}
TOCNotesSettingMenu.styles = styles;
__decorate([
    property({ attribute: false })
], TOCNotesSettingMenu.prototype, "hideIcon", void 0);
__decorate([
    property({ attribute: false })
], TOCNotesSettingMenu.prototype, "toggleHideIcon", void 0);
//# sourceMappingURL=toc-setting-menu.js.map